export default [
  {
    path: "logs",
    component: {
      name: "AdminUpmindLogs",
      template: `<router-view v-bind="$attrs" />`
    },
    meta: {
      title: "_.logs"
    },
    children: [
      {
        path: "",
        name: "admin__upmindLogs",
        redirect: { name: "admin__upmindLoginAttempts" }
      },
      {
        path: "login-attempts",
        name: "admin__upmindLoginAttempts",
        component: () =>
          import("@/views/admin/upmind/logs/loginAttempts/index.vue"),
        meta: {
          title: "_.login_attempt_log",
          backTo: "_.login_attempt_log"
        }
      }
    ]
  }
];
